import { useEffect, useState } from 'react'
import type { PhotoStore } from '@application/ports.ts'
import type { PhotoId } from '@domain/ids.ts'

/** Turns a stored photo into something an <img> can show, and tidies up after. */
export function usePhoto(photos: PhotoStore | null, id: PhotoId | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let revoked: string | null = null
    let cancelled = false
    void (async () => {
      if (!photos || id === undefined) {
        setUrl(null)
        return
      }
      // Una lectura que falla es una foto que no se ve, y nada más. Sin el
      // catch, una base cerrada bajo los pies deja una promesa rechazada sin
      // dueño, que en una tablet no sale en ninguna parte.
      const blob = await photos.get(id).catch(() => null)
      if (cancelled || !blob) return
      revoked = URL.createObjectURL(blob)
      setUrl(revoked)
    })()
    return () => {
      cancelled = true
      if (revoked) URL.revokeObjectURL(revoked)
    }
  }, [photos, id])

  return url
}
